import {
	PRE_RESET_PATCH_MENU,
	PRE_DEPLOY_PATCH_MENU,
	LAST_PATCH_MENUS_GET,
	LAST_PATCH_MENUS_BY_CHILD_GET,
	PATCH_MENU_CONTENT_GET,
	MERGE_RULES_CHILDREN_GET,
	MERGE_RULE_UPDATE,
	CASH_PERMISSIONS_GET,
	CASH_PERMISSION_UPDATE,
	MERGE_CONFIG_COPY,
	CASH_RESTRICTIONS_COPY,
	CONFIG_LOG_GET,
	STASH_LIST_GET,
	STASH_CREATE,
	STASH_RESTORE,
	STASH_DELETE,
	STASH_CONTENT_GET,
	STASH_CONTENT_EXPORT,
	PATCH_MENU_CONTENT_EXPORT,
	PATCH_DATE_UPDATE,
	PATCH_CANCEL,
	CHILD_REFS_ANALYSE,
	CHILD_REFS_RESET,
	CHILD_REFS_IMPORT,
	CHILDREN_RESET,
	CHILDREN_RESET_CLEAR,
	PLACE_SEND_MAPPING_GET,
	PLACE_SEND_MAPPING_SET,
	PLACE_SEND_MAPPING_DELETE,
} from '../constants/patchMenu';

// offset absent ou nul : première page, elle remplace la liste. Sinon, page
// suivante, elle s'y ajoute.
export const getLastPatchMenus = offset => ({
	type: LAST_PATCH_MENUS_GET,
	offset: offset || 0,
});

export const getLastPatchMenusByChild = id_menu => ({
	type: LAST_PATCH_MENUS_BY_CHILD_GET,
	id_menu,
});

// id_company n'est fourni que depuis la vue agrégée du master, où le patch
// vit dans la base d'un établissement fils.
export const getPatchMenuContent = (id_patch_menu, id_company) => ({
	type: PATCH_MENU_CONTENT_GET,
	id_patch_menu,
	id_company,
	key: id_company ? `${id_company}:${id_patch_menu}` : id_patch_menu,
});

export const resetPatchMenu = patch => {
	return { type: PRE_RESET_PATCH_MENU, patch };
};

export const resetChanges = (id_menu, date_start, id_zone) => {
	return {
		type: 'PRE_RESET_CHANGES',
		id_menu,
		date_start,
		id_zone,
	};
};

export const resetChangesMaster = id_menu => {
	return {
		type: 'PRE_RESET_CHANGES_MASTER',
		id_menu,
	};
};

export const deployPatchMenu = (patchMenu, date) => {
	return { type: PRE_DEPLOY_PATCH_MENU, patchMenu, date };
};

export const refreshChanges = () => ({ type: 'REFRESH_DAY_CHANGES' });

// Règles de synchronisation de chaque établissement, pour comparaison.
export const getMergeRulesChildren = () => ({ type: MERGE_RULES_CHILDREN_GET });

// value : 'always' (SIEGE), 'old_value' (SURCHARGES), ou '' pour MODIFIABLE
// — ce dernier cas retire la clé du JSON côté serveur.
// junction n'est fourni que pour une table d'association, où la règle vit
// sous updateOptions de cette jonction.
// toSiege dit le sens du changement plutôt que son encodage : SIEGE vaut
// 'always' pour un type unitaire et un booléen pour une association, et c'est
// l'appelant qui sait lequel il manipule.
export const updateMergeRule = (
	id_company,
	type,
	field,
	value,
	junction,
	toSiege,
	// Règles écrites dans la foulée, sur le même établissement :
	// [{ type, field, value, junction }] (Produit — Prix → prix annexes).
	extraRules = []
) => ({
	type: MERGE_RULE_UPDATE,
	id_company,
	ruleType: type,
	field,
	value,
	junction,
	toSiege,
	extraRules,
});

// Permissions caisse de la base courante (mode maison, compte fils).
export const getCashPermissions = () => ({ type: CASH_PERMISSIONS_GET });

// Active ou désactive une permission caisse. id_company cible un
// établissement depuis le siège.
export const updateCashPermission = (id_permission, active, id_company) => ({
	type: CASH_PERMISSION_UPDATE,
	id_permission,
	active,
	id_company,
});

// Recopie les règles d'un établissement (ou du siège si id_source est nul)
// vers d'autres. Remplacement complet côté cible.
export const copyMergeConfig = (id_source, id_targets) => ({
	type: MERGE_CONFIG_COPY,
	id_source,
	id_targets,
});

// Recopie les restrictions caisse — droits spéciaux et permissions — d'un
// établissement vers d'autres.
export const copyCashRestrictions = (id_source, id_targets) => ({
	type: CASH_RESTRICTIONS_COPY,
	id_source,
	id_targets,
});

// Historique des modifications d'une base : un établissement, ou le siège
// quand id_company est absent.
export const getConfigLog = id_company => ({
	type: CONFIG_LOG_GET,
	id_company,
});

// Brouillons mis de côté. La liste est propre à la carte et à la zone de
// travail — le serveur s'en charge à partir des lignes stashées.
export const getStashes = id_menu => ({ type: STASH_LIST_GET, id_menu });

export const createStash = (id_menu, name) => ({
	type: STASH_CREATE,
	id_menu,
	name,
});

export const restoreStash = (id_menu, id) => ({
	type: STASH_RESTORE,
	id_menu,
	id,
});

export const deleteStash = (id_menu, id) => ({
	type: STASH_DELETE,
	id_menu,
	id,
});

// Détail d'un stash : les lignes qui reviendraient si on le reprenait.
export const getStashContent = (id_menu, id) => ({
	type: STASH_CONTENT_GET,
	id_menu,
	id,
});

// Export XLSX. Contrairement à l'affichage, plafonné à dix lignes, l'export
// prend tout le lot — d'où une requête à part plutôt qu'une lecture du cache.
export const exportStashContent = (id_menu, id, name) => ({
	type: STASH_CONTENT_EXPORT,
	id_menu,
	id,
	name,
});

export const exportPatchMenuContent = (id_patch_menu, id_company, name) => ({
	type: PATCH_MENU_CONTENT_EXPORT,
	id_patch_menu,
	id_company,
	name,
});

// Date d'effet d'un déploiement pas encore parti. date au format AAAA-MM-JJ.
export const updatePatchDate = (id_patch_menu, date) => ({
	type: PATCH_DATE_UPDATE,
	id_patch_menu,
	date,
});

// Supprime un déploiement pas encore parti, et les modifications qu'il porte.
export const cancelPatch = id_patch_menu => ({
	type: PATCH_CANCEL,
	id_patch_menu,
});

// Références qu'un établissement possède et que le siège n'a pas.
export const analyseChildRefs = id_company => ({
	type: CHILD_REFS_ANALYSE,
	id_company,
});

// entities : les entités à reprendre, les trois par défaut.
// removed : importer en supprimé — la référence devient connue du siège sans
// entrer dans la carte.
export const importChildRefs = (id_company, entities, removed) => ({
	type: CHILD_REFS_IMPORT,
	id_company,
	entities,
	removed,
});

export const resetChildRefs = () => ({ type: CHILD_REFS_RESET });

// Supprime, depuis le siège, les modifications en cours des établissements
// choisis à la date affichée.
export const resetChildrenChanges = ids_company => ({
	type: CHILDREN_RESET,
	ids_company,
});

export const clearChildrenReset = () => ({ type: CHILDREN_RESET_CLEAR });

// Correspondance des points de fabrication entre le siège et un
// établissement. Elle s'écrit dans la base du siège.
export const getPlaceSendMapping = id_company => ({
	type: PLACE_SEND_MAPPING_GET,
	id_company,
});

// Pose ou remplace le correspondant d'un point du siège.
export const setPlaceSendMapping = (
	id_company,
	id_place_send_master,
	id_place_send_child
) => ({
	type: PLACE_SEND_MAPPING_SET,
	id_company,
	id_place_send_master,
	id_place_send_child,
});

export const deletePlaceSendMapping = (id_company, id_place_send_master) => ({
	type: PLACE_SEND_MAPPING_DELETE,
	id_company,
	id_place_send_master,
});
